/* import __COLOCATED_TEMPLATE__ from './add-pm-participants.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();